import axios from "axios";

export default class CompareService {
  private getRootUrl(): string {
    return process.env.VUE_APP_API_BASE_URL || (process.env.NODE_ENV === "development" ? "http://localhost:8000" : "");
  }

  async getCompareConfig(id: string) {
    try {
      const rootUrl = this.getRootUrl();
      const response = await axios.get(`${rootUrl}/api/compareConfig/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching compare config:", error);
      throw error;
    }
  }

  async getCompareData(compareConfigId: string) {
    try {
      const rootUrl = this.getRootUrl();
      const response = await axios.get(`${rootUrl}/api/compareData/${compareConfigId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching compare data:", error);
      throw error;
    }
  }

  async getFormStructure(compareConfigId: string) {
    try {
      const rootUrl = this.getRootUrl();
      const response = await axios.get(`${rootUrl}/api/compareFormStructure/${compareConfigId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching form structure:", error);
      throw error;
    }
  }
}









